import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Header, Grid, Dimmer, Loader, Message, Button, Card, List } from 'semantic-ui-react';
import _ from 'underscore';

import {
    editInpatientClaimBySysAdmin,
    getAllInpatientClaimBySysAdmin,
} from '../../actions';

class VerifyInpatientBank extends Component {
    state = {
        isLoading: false,
        currentPage: 1,
        perPage: 10,
        data: [],
    }

    componentWillMount() {
        if (!this.props.user.roles.find(r => r.type === 'ADMIN_ACCOUNT')) {
            this.props.history.replace("/");
        }
    }

    componentDidMount() {
        this.getData()
    }

    getData = () => {
        const { accessToken } = this.props.user;
        const params = {
            searchPage: this.state.currentPage,
            searchMax: this.state.perPage,
            proposedBankStatus: 'WAITING_VERIFICATION'
        }
        this.setState({ isLoading: true }, () => {
            this.props.getAllInpatientClaimBySysAdmin(accessToken, params, (result, error) => {
                if (result) {
                    this.setState({ data: result.inpatient, isLoading: false })
                }
                if (error) {
                    alert("There is an error get claim data");
                }
            });
        });
    }

    approveBank = (idClaim) => {
        this.setState({ isLoading: true }, () => {
            this.props.editInpatientClaimBySysAdmin(this.props.user.accessToken, { _id: idClaim, proposedBankStatus: "APPROVED" },
                (success, error) => {
                    if (success) {
                        this.setState({ isLoading: false });
                        this.getData();
                    }
                    if (error) {
                        this.setState({ isLoading: false });
                    }
                }
            );
        })
    }

    declineBank = (idClaim) => {
        this.setState({ isLoading: true }, () => {
            this.props.editInpatientClaimBySysAdmin(this.props.user.accessToken, { _id: idClaim, proposedBankStatus: "REJECTED" },
                (success, error) => {
                    if (success) {
                        this.setState({ isLoading: false });
                        this.getData();
                    }
                    if (error) {
                        this.setState({ isLoading: false });
                    }
                }
            );
        })
    }

    render() {
        return (
            <Container>
                <Grid columns="equal">
                    <Grid.Column width={16}>
                        <Header as="h2" textAlign="center">
                            Verify Claim Inpatient Bank
                        </Header>
                    </Grid.Column>
                </Grid>
                <Dimmer.Dimmable>
                    <Dimmer active={this.state.isLoading} inverted>
                        <Loader />
                    </Dimmer>
                    {!this.state.isLoading &&
                        <>
                            {
                                this.state.data.length === 0 ? <Message info>No user data.</Message>
                                    :
                                    <Card.Group>
                                        {
                                            _.map(this.state.data, (data, key) => {
                                                return (
                                                    <Card key={key}>
                                                        <Card.Content>
                                                            <Card.Meta>{data.detailUser && data.detailUser.nric ? data.detailUser.nric.toUpperCase() : ""}</Card.Meta>
                                                            <Card.Header> {data.detailUser && data.detailUser.name ? data.detailUser.name:''}</Card.Header>
                                                            <span>Transaction No : {data.transactionNo}</span>
                                                        </Card.Content>
                                                        <Card.Content>
                                                            <Card.Description>
                                                                <List>
                                                                    <List.Item>
                                                                        <List.Header>Bank Name</List.Header>
                                                                        <List.Description>{data.proposedBankDetail.bankName}</List.Description>
                                                                    </List.Item>
                                                                    <List.Item>
                                                                        <List.Header>Bank No</List.Header>
                                                                        <List.Description>{data.proposedBankDetail.bankNo}</List.Description>
                                                                    </List.Item>
                                                                    <List.Item>
                                                                        <List.Header>Branch No</List.Header>
                                                                        <List.Description>{data.proposedBankDetail.branchNo}</List.Description>
                                                                    </List.Item>
                                                                    <List.Item>
                                                                        <List.Header>Account No</List.Header>
                                                                        <List.Description>{data.proposedBankDetail.accountNo}</List.Description>
                                                                    </List.Item>
                                                                </List>
                                                            </Card.Description>
                                                        </Card.Content>
                                                        <Card.Content extra>
                                                            <div className='ui two buttons'>
                                                                <Button basic color='red' onClick={() => this.declineBank(data._id)}>Decline</Button>
                                                                <Button color='green' onClick={() => this.approveBank(data._id)}>Approve</Button>
                                                            </div>
                                                        </Card.Content>
                                                    </Card>
                                                );
                                            })
                                        }
                                    </Card.Group>
                            }
                        </>

                    }

                </Dimmer.Dimmable>
            </Container>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user.user
    }
}

export default connect(mapStateToProps, {
    editInpatientClaimBySysAdmin,
    getAllInpatientClaimBySysAdmin,
})(VerifyInpatientBank);